module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/18 zebro nizke.jpg";